import { UseMutationResult, UseQueryResult, useMutation, useQuery } from '@tanstack/react-query';
import axios, { AxiosError, AxiosResponse } from 'axios';

import { ErrorResponse, chatCustomAxios } from '@utils/customAxios';

// ------------------------------ POST /user/country/code ------------------------------
interface UserCountryCodeResponse {
  name: string;
  phoneCode: string;
  shortName: string;
}

/* 이 국가 코드 API는 첫 페이지 입장시 에러가 발생했을 때 공통으로 error을 Alert로 안 띄우고, 개별 console로 에러를 처리했다. ( 개별 요청 사항 ) */
const userCountryCode = async (): Promise<UserCountryCodeResponse[] | null> => {
  try {
    const response = await chatCustomAxios.post<UserCountryCodeResponse[]>('user/country/code');
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.log(
        'Error fetching user country code:',
        error.response?.data?.message || 'An unexpected error occurred.'
      );
    }
    return null;
  }
};

export const useUserCountryCodeQuery = (): UseQueryResult<UserCountryCodeResponse[] | null, Error> => {
  return useQuery<UserCountryCodeResponse[] | null, Error>({
    queryKey: ['userCountryCode'],
    queryFn: userCountryCode,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    gcTime: Infinity
  });
};
// ------------------------------ POST /user/country/code ------------------------------

// ------------------------------ POST /cert/sms/deletion/req ------------------------------

interface SmsDeleteRequest {
  grantType: string;
  phoneNumber: number;
  userId: string;
}

interface SmsDeleteRequestOptions {
  request: SmsDeleteRequest;
  headers: Record<string, string>;
}

const smsDeletionReq = (options: SmsDeleteRequestOptions): Promise<AxiosResponse<any>> => {
  return chatCustomAxios.post('cert/sms/deletion/req', options.request, {
    headers: options.headers
  });
};
export const useSmsDeleteRequestMutation = (): UseMutationResult<
  AxiosResponse<any>,
  AxiosError<ErrorResponse>,
  SmsDeleteRequestOptions,
  unknown
> => {
  return useMutation<AxiosResponse<any>, AxiosError<ErrorResponse>, SmsDeleteRequestOptions, unknown>({
    mutationFn: smsDeletionReq
  });
};

// ------------------------------ POST /cert/sms/deletion/req ------------------------------

// ------------------------------ POST /cert/sms/deletion/cert ------------------------------

interface SmsDeleteCertRequest {
  certNumber: number;
  grantType: string;
  phoneNumber: number;
  userId: string;
}

interface SmsDeleteCertRequestOptions {
  request: SmsDeleteCertRequest;
  headers: Record<string, string>;
}

const smsDeletionCertification = (options: SmsDeleteCertRequestOptions): Promise<void> => {
  return chatCustomAxios
    .post('cert/sms/deletion/cert', options.request, {
      headers: options.headers
    })
    .then((res) => res.data);
};
export const useSmsDeleteCertificationMutation = (): UseMutationResult<
  void,
  AxiosError<ErrorResponse>,
  SmsDeleteCertRequestOptions,
  unknown
> => {
  return useMutation<void, AxiosError<ErrorResponse>, SmsDeleteCertRequestOptions, unknown>({
    mutationFn: smsDeletionCertification
  });
};

// ------------------------------ POST /cert/sms/deletion/cert ------------------------------

// ------------------------------ DELETE /user/deletion ------------------------------

interface UserDeletionRequest {
  phoneNumber: number;
  userId: string;
}

interface UserDeletionRequestOptions {
  request: UserDeletionRequest;
  headers: Record<string, string>;
}

const deleteChatUserData = (options: UserDeletionRequestOptions): Promise<void> => {
  return chatCustomAxios
    .delete('user/deletion', {
      data: options.request,
      headers: options.headers
    })
    .then((res) => res.data);
};

export const useDeleteChatUserDataMutation = (): UseMutationResult<
  void,
  AxiosError<ErrorResponse>,
  UserDeletionRequestOptions,
  unknown
> => {
  return useMutation<void, AxiosError<ErrorResponse>, UserDeletionRequestOptions, unknown>({
    mutationFn: deleteChatUserData
  });
};

// ------------------------------ DELETE /user/deletion ------------------------------
